/**
 * 【KYMW5002】使用履歴一覧取得VO
 *
 * @export GetUseRecordListModel
 * @class GetUseRecordListModel
 */
export class GetUseRecordListModel {
  /** コマID  */
  public coopCode = String('');
  /** Ｐコード  */
  public pcode = String('');
  /** 今回受注コード  */
  public thisOrderCode = String('');
}
